module.exports = __webpack_public_path__ + "media/images/icon__email@3x-cf6c8347b94cea03c0845853769efa6c.png";